"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  allBrands: 'All brands',
  articles: 'Articles',
  brands: 'Brands',
  callToActionCatalogueText: 'Call to action catalogue text',
  change: 'Change',
  clearSearchInput: 'Clear search input',
  failedToSubmit: 'Failed to submit',
  favouriteLists: 'Favourite lists',
  gotIt: 'Got it',
  loading: 'Loading',
  logIn: 'Log in',
  loggedInAs: 'Logged in as',
  menu: 'Menu',
  myAccount: 'My account',
  myFavoriteProducts: 'My favorite products',
  nextCatalogue: 'Next catalogue',
  noOptions: 'No options',
  notifications: 'Notifications',
  open: 'Open',
  oriflameSweden: 'Oriflame Sweden',
  other: 'Other',
  popularProducts: 'Popular products',
  popularProductsInThisSearchQuery: 'Popular products in this search query',
  popularSearchQueries: 'Top result for',
  products: 'Products',
  register: 'Register',
  search: 'Search',
  searchDesktop: 'Search 60+ brands, 1000+ beauty and nutrition products',
  seeAll: 'See all',
  seeAllCatalogues: 'See all catalogues',
  seeAllResultsFor: 'See all results ({count})',
  shopFor: 'Shop for',
  shoppingBag: 'Shopping bag',
  signIn: 'Sign in',
  topAreaBannerDialogError: 'Error while loading data, please try again later.',
  topAreaBannerReferralMessage: 'Click to see more info!',
  view: 'View'
};
const translationsNamespace = exports.translationsNamespace = 'top-area';
